<template>
    <div class="settings-page__about-us">
        <about-us ref="aboutUs" @ready="onReadAboutUs" @start="onStartAboutUs" />
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartAboutUs = (): void => {
        emit("data-loading", true);
    };
    const onReadAboutUs = (): void  => {
        emit("data-loading", false);
    };
</script>
